import * as React from "react";
import "./static/VerifyActionDialog.scss";
import BaseComponent from "../../utility/BaseComponent";
import { AsyncOperationsModel } from "../../utility/AsyncOperationsModel";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import { DialogContainer, CircularProgress, Card, CardText } from "react-md";
import { Observable } from "rxjs/Observable";
import { isNullOrUndefined } from "util";

export interface VerifyActionDialogProps<T, R> {
    model: VerifyActionDialogModel<T>;
    showDialog: boolean;
    body: string; 
    operation: Observable<R>;
    tag: string;
    onCompleteFunction: Function;
    title: string;
}
export interface VerifyActionDialogState {
    showDialog: boolean;
}
export class VerifyActionDialogModel<T> extends AsyncOperationsModel {
    @observable items: T[];
 
    @action.bound
    setItems(items: T[]) {
        this.items = items;
    }
    @action.bound
    resetAsyncOperations() {
        this.asyncOperationsCount = 0;
    }
    
}
@observer class VerifyActionDialog<T, R> extends BaseComponent<VerifyActionDialogProps<T, R>, VerifyActionDialogState> {
    constructor(props: VerifyActionDialogProps<T, R>) {
        super(props);
        this.state = {
            showDialog: props.showDialog
        };
        this.hideDialog = this.hideDialog.bind(this);
        this.executeOperation = this.executeOperation.bind(this);
    }
    executeOperation() {
        if (!isNullOrUndefined(this.props.model.items) && this.props.model.items.length > 0 ) {
            this.props.model.incrementAsyncOperations();
            this.props.operation.first().subscribe(
                result => {
                    this.props.model.resetAsyncOperations();
                    this.props.onCompleteFunction(false);
                },
                error => {
                    this.props.model.setErrorMessages([error.message]);
                    this.props.model.resetAsyncOperations();
                    this.componentDidCatch(error, {
                        componentStack: "VerifyActionDialogModel [DELETE]"
                    });
                }
            );
        }
    }
    hideDialog() {
        this.props.model.resetAsyncOperations();
        this.setState({showDialog: false});
        this.props.onCompleteFunction(true);
    }
    
    componentWillReceiveProps(nextProps: VerifyActionDialogProps<T, R>) {
        this.props = nextProps;
        this.setState({showDialog: this.props.showDialog});
    }
    render() {
        return (
            <DialogContainer
                className="DeleteUsersDialog"
                id="deleteUsers"
                visible={this.state.showDialog}
                title={this.props.title}
                onHide={() => this.hideDialog()}
                modal={true}
                actions={[
                    {
                        onClick: this.executeOperation,
                        secondary: true,
                        children: "OK"
                    },
                    {
                        onClick: this.hideDialog,
                        secondary: true,
                        children: "Cancel"
                    }
                ]}
            >
            {           this.props.model.asyncOperationsCount === 0 && 
                        this.props.model.errorMessages.length > 0 &&
                        <Card className="messagesCard">
                            <CardText className="messageText">
                                {
                                    this.props.model.errorMessages.map(
                                        (item, index) => {
                                            return <p key={index}>{item}</p>;
                                        }
                                    )
                                }
                            </CardText>
                        </Card>
                    }
            {
                this.props.model.asyncOperationsCount > 0 && 
                <CircularProgress id="progress" centered={true}/>
            }
            {
                this.props.model.asyncOperationsCount === 0 && 
                <p> 
                {this.props.body}
                </p>

            }
            </DialogContainer>
        );
    }
}

export default VerifyActionDialog;


// WEBPACK FOOTER //
// ./src/component/VerifyActionDialog/VerifyActionDialog.tsx